import React from 'react';
import { getTrainColor } from '../../../../common/tranists';
import { SvgLowFloorIcon } from '../../../atoms/svg/LowFloorIcon';

type Props = {
  trainNo: number;
  course: number;
  logo: boolean;
  selected: boolean;
  onClick: () => void;
};

export const TrainSVG: React.FC<Props> = (props) => {
  const { trainNo, course, logo, selected, onClick } = props;
  return (
    <svg
      width='100%'
      height='100%'
      viewBox='0 0 100 125'
      textRendering='geometricPrecision'
      onClick={onClick}
    >
      <g>
        {/* 内側 */}
        <g>
          <path
            stroke='grey'
            strokeWidth='2'
            fill={getTrainColor(course)}
            d='M50,10 l-41,20 v85 h82 v-85 Z'
          ></path>
          <g>
            <text
              x={50}
              y={logo ? 55 : 75}
              fontSize={23}
              fontFamily='sans-serif'
              fontWeight='bold'
              textAnchor='middle'
            >
              {trainNo}
            </text>
            {logo && (
              <g transform={`translate(${27}, ${62}) scale(${0.31})`}>
                <SvgLowFloorIcon></SvgLowFloorIcon>
              </g>
            )}
          </g>
        </g>

        {/* 外枠 */}
        {selected && (
          <g>
            <path
              stroke='#FFC410'
              strokeWidth='5'
              fill='none'
              d='M50,3 L3,27 v94 h94 v-94 Z'
            ></path>
          </g>
        )}
      </g>
    </svg>
  );
};
